import Head from "next/head";

type NoIndexProps = {
  /** The robots directive; `noindex,follow` keeps a page out of the index but lets its links count. */
  content?: "noindex" | "noindex,follow";
};

/**
 * Keyed so that a page emitting more than one robots directive ends up with a single tag: Next
 * de-duplicates head children by `key`, and the last one rendered wins.
 */
export const NoIndex = ({ content = "noindex" }: NoIndexProps) => {
  return (
    <Head>
      <meta key="robots" name="robots" content={content} />
    </Head>
  );
};
